import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./styles/tokens.css";
import "./styles/app.css";
import { App } from "./App.js";
import { I18nProvider } from "./lib/i18n.js";
import { SessionProvider } from "./lib/SessionContext.js";
import { ToastProvider } from "./components/Toast.js";

const el = document.getElementById("root");
if (!el) throw new Error("#root not found");

createRoot(el).render(
  <StrictMode>
    <I18nProvider>
      <SessionProvider>
        <ToastProvider>
          {/* Opt into the v7 behaviours now: no behavioural change today, but the
              console stays clean and the upgrade is a version bump, not a refactor. */}
          <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <App />
          </BrowserRouter>
        </ToastProvider>
      </SessionProvider>
    </I18nProvider>
  </StrictMode>
);
